<template>
  <v-card>
    <v-toolbar color="indigo darken-1" dark dense>
      <v-toolbar-title class="text-body-1">
        <v-icon left>mdi-access-point</v-icon>{{$t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.TITLE')}}
      </v-toolbar-title>
    </v-toolbar>
    <v-list>
      <v-subheader class="font-weight-light">
        <v-icon class="mr-2" small>mdi-clock</v-icon>{{$t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.INFO')}}
      </v-subheader>
      <v-sheet
        class="v-sheet--offset mx-auto mb-3 rounded-lg"
        color="indigo"
        max-width="calc(100% - 32px)"
      >
        <v-sparkline :value="countList" color="white" line-width="2" padding="16">
          <template v-slot:label="item">
            {{item.index+1 == 1 ? $t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.DAY_TH', { DAY: item.index+1 }) : ''}}
            {{item.index+1 == 7 ? $t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.DAY_TH', { DAY: item.index+1 }) : ''}}
            {{item.index+1 == 14 ? $t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.DAY_TH', { DAY: item.index+1 }) : ''}}
            {{item.index+1 == 21 ? $t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.DAY_TH', { DAY: item.index+1 }) : ''}}
            {{item.index+1 == 28 ? $t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.DAY_TH', { DAY: item.index+1 }) : ''}}
          </template>
        </v-sparkline>
      </v-sheet>
      <!-- <v-list-item :key="index" v-for="(item, index) in statsList"> -->
      <v-list-item>
        <v-list-item-avatar>
          <v-btn fab outlined class="indigo lighten-5" color="indigo darken-1" dark small>
            <v-icon size="18">mdi-monitor</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-subtitle-2 grey--text text--darken-4">{{$t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.ACCESS_TYPES.DESKTOP')}}:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-chip class="px-5">
            <b class="text-subtitle-2">{{platforms.D}}</b>
          </v-chip>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-avatar>
          <v-btn fab outlined class="indigo lighten-5" color="indigo darken-1" dark small>
            <v-icon size="18">mdi-cellphone-dock</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-subtitle-2 grey--text text--darken-4">{{$t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.ACCESS_TYPES.MOBILE')}}:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-chip class="px-5">
            <b class="text-subtitle-2">{{platforms.M}}</b>
          </v-chip>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-avatar>
          <v-btn fab outlined class="indigo lighten-5" color="indigo darken-1" dark small>
            <v-icon size="18">mdi-tablet</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-subtitle-2 grey--text text--darken-4">{{$t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.ACCESS_TYPES.TABLET')}}:</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-chip class="px-5">
            <b class="text-subtitle-2">{{platforms.T}}</b>
          </v-chip>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-list-item-content></v-list-item-content>
        <v-list-item-action>
          <v-chip color="indigo lighten-4" class="px-5">
            <span class="indigo--text mr-2">{{$t('ISTATISTIKLER.DASHBOARD.ACCESS_SUMMARY.ACCESS_TOTAL')}}:</span>
            <b class="indigo--text text-subtitle-2">{{totalStats}}</b>
          </v-chip>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import IstatistiklerService from "@/services/IstatistiklerService";
export default {
  name: "Stats",
  data: () => ({
    daysLimit: 28,
    stats: `28 days`,
    statsList: [],
    // labels: ["3. gün", "7. gün",  "14. gün", "21. gün", "28. gün"],
    platforms: {
      D: "",
      M: "",
      T: ""
    },
    countList: []
  }),
  computed: {
    totalStats() {
      return this.platforms.D + this.platforms.M + this.platforms.T;
    }
  },
  methods: {
    parseDate() {
      this.statsList.forEach(item => {
        console.log(item);
      });
    }
  },
  created() {
    let { stats } = this,
      statsProcess = [];
    for (let p in this.platforms) {
      let is = p;
      statsProcess.push(
        IstatistiklerService.getStats({ stats, is }).then(res => {
          if (res.status === 200) {
            this.platforms[p] = res.data.count;
          }
        })
      );
    }

    /**
     * Sparkline için istatistikleri getir
     */
    Promise.all(statsProcess).then(() => {
      let limit = this.totalStats,
        order = "asc";
      IstatistiklerService.getStats({ stats, limit, order })
        .then(res => {
          if (res.status === 200) {
            this.statsList = res.data.list;
          }
        })
        .then(() => {
          let timeLine = [];
          for (let i = 0; i < this.daysLimit; i++) {
            timeLine.push(
              new Date(Date.now() - 86400000 * i).toISOString().slice(0, 10)
            );
          }
          timeLine = timeLine.reverse()

          let statsList = [];
          this.statsList.forEach(item => {
            statsList.push(new Date(item.date).toISOString().slice(0, 10));
          });

          let countList = [];
          timeLine.forEach(item => {
            countList.push(statsList.reduce(function(n, val) {
              return n + (val === item);
            }, 0));
          });

          this.countList = countList;
        });
    });
  }
};
</script>

<style>
</style>